import { useEffect } from 'react'

export const usePhone = setDataModal => {
  useEffect(() => {
    setDataModal(null)
  }, [setDataModal])
}
